// @flow
import React from "react";
import {useFormik} from "formik";
import {useObserver} from "mobx-react-lite";
import {Form, Input, Row} from "antd";
import {useTranslation} from "react-i18next";

import {useStore} from "../../../hooks/useStore";
import {changePasswordValidation} from "./changePasswordValidations";
import {changePasswordFormType} from "./cpfPropTypes";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";

export const ChangePasswordForm = ({isCustomer}) => {
    const stores = useStore();
    const {t} = useTranslation(["changePasswordForm"]);
    const formik = useFormik({
        initialValues: {oldPassword: "", password: "", passwordConfirm: ""},
        validationSchema: changePasswordValidation,
        onSubmit: async (values: changePasswordFormType) => {
            await stores.meStore.changePassword(values);
            await resetForm();
        }
    });

    const {values, errors, touched, handleChange, handleSubmit, isSubmitting, resetForm} = formik;

    return useObserver(() => (
        <Form
            onFinish={handleSubmit}
            labelCol={{span: 6}}
            wrapperCol={{span: 18}}
            autoComplete="off"
            data-testid="changePasswordForm"
        >
            <Form.Item
                colon={false}
                label={t("changePasswordForm.fields.oldPassword", {ns: "changePasswordForm"})}
                labelAlign="left"
                validateStatus={errors.oldPassword && touched.oldPassword ? "error" : "success"}
                help={errors.oldPassword && touched.oldPassword ? errors.oldPassword : null}
            >
                <Input.Password
                    name="oldPassword"
                    data-testid="oldPasswordINput"
                    value={values.oldPassword}
                    onChange={handleChange}
                    autoComplete="new-password"
                />
            </Form.Item>
            <Form.Item
                colon={false}
                label={t("fields.password", {ns: "common"})}
                labelAlign="left"
                validateStatus={errors.password && touched.password ? "error" : "success"}
                help={errors.password && touched.password ? errors.password : null}
            >
                <Input.Password
                    name="password"
                    data-testid="passwordInput"
                    value={values.password}
                    onChange={handleChange}
                />
            </Form.Item>
            <Form.Item
                colon={false}
                label={t("changePasswordForm.fields.passwordAgain", {ns: "changePasswordForm"})}
                labelAlign="left"
                validateStatus={
                    errors.passwordConfirm && touched.passwordConfirm ? "error" : "success"
                }
                help={
                    errors.passwordConfirm && touched.passwordConfirm
                        ? errors.passwordConfirm
                        : null
                }
            >
                <Input.Password
                    name="passwordConfirm"
                    data-testid="passwordConfirmInput"
                    value={values.passwordConfirm}
                    onChange={handleChange}
                />
            </Form.Item>
            <Row type="flex" justify="end">
                <CustomButton
                    disabled={isSubmitting}
                    type="ghost"
                    htmlType="submit"
                    data-testid="submitButton"
                    style={{
                        backgroundColor: isCustomer ? "#AEFF01" : "transparent"
                    }}
                >
                    {t("actions.save", {ns: "common"})}
                </CustomButton>
            </Row>
        </Form>
    ));
};
